import React from 'react'
import { StoreStatus } from '../../../types/enum/storeStatus'
import { useStoresByAdmin } from '../../../hooks/admin/store.admin'
import { useSearchParams } from 'react-router-dom'
import Pagination from '../../ui/Pagination'
import LoadingErrorState from '../../ui/LoadingErrorState'
import EmptyData from '../../ui/EmptyData'
import StoreBoxAdmin from './StoreBoxAdmin'

type Props ={
    status:StoreStatus
}

function AdminStoresOverViewParent({status}:Props) {
    const [searchParams,setSearchParams] = useSearchParams();
    const pageQuery = Number(searchParams.get('page')) || 1;
    const name = searchParams.get('name')?? "";
    const phone = searchParams.get('phone')?? "";
    const commercialRegister = searchParams.get("commercialRegister") ??"";
    const city = searchParams.get('city')?? "";
    const type = searchParams.get('type')?? "";
    const subType = searchParams.get('subType')?? "";
    const dateFilter = searchParams.get('dateFilter')?? "";


    const handlePagination = (page: number) => {
            const newParams = new URLSearchParams(searchParams);
            newParams.set('page', page.toString());
            setSearchParams(newParams);
        };

    const {data,isError,isLoading} = useStoresByAdmin({page:pageQuery,status,name,phone,commercialRegister,city,type,subType,dateFilter});
  return (
    <div>
        <LoadingErrorState
        isError={isError}
        isLoading={isLoading}
        type="grid"
        />
        {
        (data && data.stores && data.stores.length>0) ?
        <>
        <div className='grid md:grid-cols-2 xl:grid-cols-3 gap-8 mt-8'>
          {
            data.stores.map(st=>{
            return <StoreBoxAdmin key={st.id+"demk"} store={st} status={status}/>
          })
          }
        </div>
        <div>
            <Pagination
                handlePagination={handlePagination}
                totalPages={data.totalPages}
                currentPage={pageQuery}
            />
          </div>
        </>
        :
        !isLoading ?<EmptyData/>:""
      }
    </div>
  )
}

export default AdminStoresOverViewParent